import {
	defAction
}from "../../../../helpers/defaultAction"
import {
	reInfoOrgTypeConstants
}from "./constants"
import api from './api'

export const reInfoOrgTypeActions = {
	getPaged,
	getPagedAudit,
	getPagedAll,
	getList,
	create,
	remove,
	update,
	restore,
	clear
}

function getPaged(values){
	const dispatchObj = {
		constants : reInfoOrgTypeConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function getPagedAudit(values){
	const dispatchObj = {
		constants : reInfoOrgTypeConstants.GetPagedAudit,
		service   : {
			func   : api.getPagedAudit,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAll(values){
	const dispatchObj = {
		constants : reInfoOrgTypeConstants.GetPagedAll,
		service   : {
			func   : api.getPagedAll,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getList(values){
	const dispatchObj = {
		constants : reInfoOrgTypeConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : reInfoOrgTypeConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : reInfoOrgTypeConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restore(values){
	const dispatchObj = {
		constants : reInfoOrgTypeConstants.Restore,
		service   : {
			func   : api.restore,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : reInfoOrgTypeConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reInfoOrgTypeConstants.CLEAR
	})
}